import { useEffect, useState } from "react";
import React from "react";
import { MDBContainer } from "mdb-react-ui-kit";
import "../GridFilter.css";
import "datatables.net";
// import AddCircleOutlineSharpIcon from '@mui/icons-material/AddCircleOutlineSharp';


import "datatables.net";
import "datatables.net-fixedheader";
import { BounceLoader } from "react-spinners";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import FilterListIcon from "@mui/icons-material/FilterList";

import moment from "moment";

import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
} from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TablePagination } from "@mui/material";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { MobileDatePicker } from "@mui/x-date-pickers/MobileDatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { setAgent, setCity, setHotel } from "../../Store/Slices/countrySlice";
import dayjs from "dayjs";
import { makePostRequest } from "../../API";

import { getCurrentYearDatesISO } from "../../Helper/Helper";
import ActualHotalReturnModal from "../reuseableComponents/ActualHotalReturnModal";
import AllowHotalModal from "../reuseableComponents/Modals/AllowHotalModal";

const dateFormat = "YYYY-MM-DD";

function AllowHotelMakkahGridFilter() {
  // states
  const [tableData, setTableData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [isFormVisible, setFormVisible] = useState(false);
  const [expandedRows, setExpandedRows] = useState([]);
  const storeState = useSelector((state) => state);
  const dispatch = useDispatch();



    const { firstDate, lastDate } = getCurrentYearDatesISO();

  const [state, setState] = useState({
    length: 100,
    start: 0,
    draw: 1,
    voucher_id: "",
    agent_country: "",
    country: "",
    agents: "",
    city: 258342,
    hotel: "",
    check_in_date_from: firstDate,
    check_in_date_to: lastDate,
    check_out_date_from: firstDate,
    check_out_date_to:lastDate ,
    arrival_date_from: firstDate,
    arrival_date_to: lastDate,
    checkInDateTo: null,
    return_date_from: firstDate,
    return_date_to: lastDate,
    completed: "no",
  });
  // end point work

  const state_endpoints_mapping = {
    agent_country: {
      endpoint: "api/agent",
      field: "country_code",
      dispatchFunction: setAgent,
      dependent: "agents",
    },
    country: {
      endpoint: "api/world/cities",
      field: "country_id",
      dispatchFunction: setCity,
      dependent: "city",
    },
    city: {
      endpoint: "api/hotel",
      field: "city_id",
      dispatchFunction: setHotel,
      dependent: "hotel",
    },
    voucherId: null,
    agent: null,
    hotel: null,
    arrivalDate: null,
    returnDate: null,
    checkIn: null,
    checkOut: null,
    completed: null,
  };

  const loadData = async (state_id, value) => {
    if (state_endpoints_mapping[state_id] == null) return;
    setLoading(true);

    const response = await makePostRequest(
      state_endpoints_mapping[state_id].endpoint,
      { [state_endpoints_mapping[state_id].field]: value }
    );

    if (response.status == "success") {
      dispatch(
        state_endpoints_mapping[state_id].dispatchFunction(response.data)
      );
      // setState({
      //   ...state,
      //   [state_endpoints_mapping[state_id].dependent]: response.data,
      // });
    }

    setLoading(false);
  };

  const handleChange = async (e) => {
    e.preventDefault();
    const { id, value } = e.target;

    if (id === "country") {
      setState((prev) => ({
        ...prev,
        [id]: value,
        city: "", // reset selected agent
      }));
    } else {
      setState((prev) => ({
        ...prev,
        [id]: value,
      }));
    }

    // setState({ ...state, [id]: value });

    await loadData(id, value);
  };

  const handleFilterClick = () => {
    setFormVisible(!isFormVisible);
  };



  // new pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalRecords, setTotalRecords] = useState(0); // new state
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    setExpandedRows([]);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // reset to first page
  };



const [activeFilters, setActiveFilters] = useState(null); 




const fetchData = async (filters = null) => {
  const endpoint = "api/umrah/allow-hotel-activity";

  // Merge current state with any filters passed
  const params = {
    ...state,
    ...(filters || {}),
    length: rowsPerPage,
    start: page * rowsPerPage,
    draw: 1,
    
  };

  try {
    setLoading(true);
    const response = await makePostRequest(endpoint, params);
    setLoading(false);

    if (response?.data?.data) {
      setTableData(response.data.data);
      setTotalRecords(response.data.recordsTotal || response.data.total || 0);
    }
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};



useEffect(() => {
  fetchData(state);
}, [page, rowsPerPage]);







  const toggleExpansion = (index) => {
    const newExpandedRows = [...expandedRows];

    newExpandedRows[index] = !newExpandedRows[index];
    setExpandedRows(newExpandedRows);
  };



  // navigate function

  const [selectedActions, setSelectedActions] = useState({});

  // scroll top heading


  // for getting country of agent
  const [apiCountry, setApiCountry] = useState([]);
  const [apiagent, setApiagent] = useState([]);
  // country

  useEffect(() => {
    const fetchdata = async () => {
      try {
        const countries = await makePostRequest("/api/world/countries");

        const contryList = countries.data.map((country) => {
          return [country.ISO2, country.Name];
        });

        setApiCountry(contryList);
      } catch (error) {
        console.log(error?.message);
      }
    };
    fetchdata();
  }, []);


  const handleCountryChange = async (selectedCountry) => {
    setState((prev) => ({
      ...prev,
      agent_country: selectedCountry,
      agents: "", // reset selected agent
    }));

    if (!selectedCountry) {
      setApiagent([]);
      return;
    }
    try {
      setState((prevState) => ({
        ...prevState,
        agent_country: selectedCountry,
      }));

      const response = await makePostRequest("/api/agent", {
        country_code: selectedCountry,
      });

      setApiagent(response?.data ?? []);
    } catch (error) {
      console.error("Error fetching agent data:", error.message);
      setApiagent([]);
    }
  };

  // new date work flow

  const [DateError, SetDateError] = useState({
    arivalErrorFrom: false,
    arivalError: false,
    returnFrom: false,
    returnTo: false,
    CheckOutFrom: false,
    CheckOutTo: false,
    checkInFrom: false,
    checkInTo: false,
  });

  const handle_date_from = (e, positionFrom, ErrorPosition, StateCompare) => {
    const date_from = moment(e.$d).format(dateFormat);
    setState((prevState) => ({
      ...prevState,
      [positionFrom]: date_from,
    }));

    if (date_from && state[StateCompare] && date_from > state[StateCompare]) {
      SetDateError({
        ...DateError,
        [ErrorPosition]: true,
      });

      setState((prevState) => ({
        ...prevState,
        [positionFrom]: null,
      }));
    } else {
      SetDateError({
        ...DateError,
        [ErrorPosition]: false,
      });
    }
  };

  const handle_date_to = (
    e,
    positionto,
    DateErrorTo,
    DateErrorFrom,
    StateCompare
  ) => {
    const date_to = moment(e.$d).format(dateFormat);

    if (!state[StateCompare] || (date_to && date_to >= state[StateCompare])) {
      setState({
        ...state,
        [positionto]: date_to,
      });

      SetDateError({
        ...DateError,
        [DateErrorTo]: false,
        [DateErrorFrom]: false,
      });
    } else {
      setState({
        ...state,
        [positionto]: null,
      });

      SetDateError({
        ...DateError,
        [DateErrorTo]: true,
      });
    }
  };

  // models



  const [open, setOpen] = React.useState(false);
  const [openReturnVoucher, setOpenReturnVoucher] = useState(false);
 const [sendDataToModal,setSendDataToModal]=useState(null)
  
  const handleNavigate = (e, index) => {
    const selectedValue = e.target.value;
    setSelectedActions((prev) => ({
      ...prev,
      [index]: selectedValue, 
    }));

const [voucherId, key, record_id, param, refrance_type] =   selectedValue.split(",").map(v => v === "" ? null : v);


 
 let parsedData = {
    voucher_id: Number(voucherId),
    key: key,
    record_id: Number(record_id),
    actual_param:param,
    reference_type:refrance_type,
  };


setSendDataToModal( parsedData)



if(parsedData?.key ==="accommodation"){
   setOpenReturnVoucher(true)

}


else{
  setOpen(true);
}

 };


  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setIsScrolled(true);
      } else {
        setIsScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  // consoles
  // console.log("selectedActions",selectedActions);
  //  console.log("apiCountry",apiCountry)
  console.log("state", state);
  useEffect(()=>{
     window.scrollTo({ top: 0, behavior: "smooth" });
},[open])
const hasNoDateErrors = Object.values(DateError).every(v => v === false);


  //  console.log("storeState.Country.city",storeState.Country.city)
  
  return (
    <div>
      <MDBContainer breakpoint=" ">
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <div className="row mb-5 ">
            <div
              className={`mb-3 grid-filter-inputs flex-display-container align-items-center  sticky-top rounded  p-4 ${
                isScrolled ? "bg-white" : ""
              } `}
            >
              <h1 className="main-hading">Allow Hotel Makkah</h1>
              <button onClick={handleFilterClick} className="filter-button">
                Filters {<FilterListIcon />}
              </button>
            </div>
            <div className="row">
              <hr />
            </div>
            {isFormVisible && (
              <div className="row">
                <div className="col-md-12 mx-auto">
                  <div className="row">
                    {/* Voucher  */}
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="voucher_id" className="lableSize">
                          Voucher Id
                        </label>
                        <input
                          type="text"
                          className="form-control inputSizeForAllowHotel"
                          style={stylesInput}
                          onChange={handleChange}
                          id="voucher_id"
                          name="VoucherId"
                          placeholder="Voucher ID"
                          value={state.voucher_id}
                        />
                      </div>
                    </div>
                    {/* this is agent counrty  */}

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="agent_country" className="lableSize">
                          Agent Country{" "}
                        </label>

                        <select
                          className="form-control inputSizeForAllowHotel"
                          style={stylesInput}
                          id="agent_country"
                          name="AgentCountry"
                          onChange={(e) => handleCountryChange(e.target.value)}
                          value={state.agent_country}
                        >
                          <option value="">Please Select</option>
                          {apiCountry?.map((country) => {
                            return (
                              <option key={country[0]} value={country[0]}>
                                {country[1]}
                              </option>
                            );
                          })}
                        </select>
                      </div>
                    </div>
                    {/* this is agent  */}
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="agents" className="lableSize">
                          Agents
                        </label>
                        <select
                          className="form-control inputSizeForAllowHotel"
                          style={stylesInput}
                          id="agents"
                          value={state.agents || ""}
                          onChange={handleChange}
                        >
                          <option value="">Select Agent</option>
                          {state.agent_country === "" ? (
                            <option value="">Select Agent Country first</option>
                          ) : apiagent.length === 0 ? (
                            <option value="">No agent available</option>
                          ) : (
                            apiagent.map((ag) => (
                              <option key={ag.UID} value={ag.UID}>
                                {ag.FullName}
                              </option>
                            ))
                          )}
                        </select>
                      </div>
                    </div>

                    {/* country */}
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="country" className="lableSize">
                          Country{" "}
                        </label>

                        <select
                          style={stylesInput}
                          className="form-control inputSizeForAllowHotel"
                          id="country"
                          name="Country"
                          onChange={handleChange}
                          value={state.country}
                        >
                          <option value="">Please Select</option>
                          {apiCountry?.map((country) => (
                            <option key={country[0]} value={country[0]}>
                              {country[1]}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* city */}
                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="city" className="lableSize">
                          City
                        </label>

                        <select
                          className="form-control inputSizeForAllowHotel"
                          id="city"
                          name="City"
                          onChange={handleChange}
                          value={state.city}
                          style={stylesInput}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.city.map((city) => (
                            <option key={city.UID} value={city.UID}>
                              {city.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* hotels */}

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label for="hotel" className="lableSize">
                          Hotel
                        </label>
                        <select
                          className="form-control inputSizeForAllowHotel"
                          style={stylesInput}
                          id="hotel"
                          name="Hotel"
                          onChange={handleChange}
                          value={state.hotel}
                        >
                          <option value="">Please Select</option>
                          {storeState.Country.hotel.map((trans) => (
                            <option key={trans.UID} value={trans.UID}>
                              {trans.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>

                    {/* -------------------------------------------------------------- check In */}

                    <>
                      <label
                        for="arrival_date"
                        className="fs-1 text-center mt-3 "
                      >
                        CheckIn Date
                      </label>

                      <div className="col-md-2 mb-1">
                        <div className="form-group">
                          <label for="checkin_date" className="fs-2">
                            {" "}
                            From
                          </label>

                          <DemoContainer
                            components={[
                              "DatePicker",
                              "MobileDatePicker",
                              "StaticDatePicker",
                            ]}
                            sx={{
                              "& .MuiInputBase-root": {
                                borderRadius: "10px",
                              },
                              "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "transparent",
                                },

"& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },


                            }}
                          >
                            <MobileDatePicker
                              value={dayjs(
                                state.check_in_date_from,
                                dateFormat
                              )}
                              onChange={(e) =>
                                handle_date_from(
                                  e,
                                  "check_in_date_from",
                                  "checkInFrom",
                                  "check_in_date_to"
                                )
                              }
                              className=""
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "1.3rem",
                                  backgroundColor: "transparent",
                                  border:
                                     "gray 1px solid",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "transparent",
                                    },
                                    
                                    
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },

                                
                              }}
                            />
                          </DemoContainer>














                          

                          {DateError.checkInFrom ||
                          (DateError.checkInFrom &&
                            state.check_in_date_from == null) ? (
                            <div>
                              <p className="text-danger mt-3 f-bold ">
                                PLEASE SELECT CORRECT ARIVAL FROM DATE
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}

                          <label for="arrival_date" className="fs-2 mt-3">
                            {" "}
                            To
                          </label>
                          <DemoContainer
                            components={[
                              "DatePicker",
                              "MobileDatePicker",
                              "StaticDatePicker",
                            ]}
                            sx={{
                              "& .MuiInputBase-root": {
                                borderRadius: "10px",
                              },
                              "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "transparent",
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },

                            }}
                            autoFocus={false}
                          >
                            <MobileDatePicker
                              value={dayjs(state.check_in_date_to, dateFormat)}
                              className=" "
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "1.3rem",
                                  backgroundColor: "transparent",
                                  border:
                                     "gray 1px solid",
                                  outline: DateError.checkInTo ? "none" : "",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "transparent",
                                    },
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                              }}
                              onChange={(e) =>
                                handle_date_to(
                                  e,
                                  "check_in_date_to",
                                  "checkInTo",
                                  "checkInFrom",
                                  "check_in_date_from"
                                )
                              }
                              autoFocus={false}
                            />
                          </DemoContainer>

                          {DateError.checkInTo ||
                          (DateError.checkInTo &&
                            state.check_in_date_to == null) ? (
                            <div>
                              <p className="text-danger mt-3 f-bold ">
                                PLEASE SELECT CORRECT ARIVAL TO DATE
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </>

                    {/* -------------------------------------------------------------- CheckOut */}

                    <>
                      <label
                        for="
                        travel_date"
                        className="fs-1 text-center mt-3 "
                      >
                        {" "}
                        Check Out Date{" "}
                      </label>
                      <div className="col-md-2 mb-1">
                        <div className="form-group">
                          <label for="check_out_date_from" className="fs-2">
                            {" "}
                            From
                          </label>

                          <DemoContainer
                            components={[
                              "DatePicker",
                              "MobileDatePicker",
                              "StaticDatePicker",
                            ]}
                            sx={{
                              "& .MuiInputBase-root": {
                                borderRadius: "10px",
                              },
                              "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "transparent",
                                },
                            }}
                          >
                            <MobileDatePicker
                              onChange={(e) =>
                                handle_date_from(
                                  e,
                                  "check_out_date_from",
                                  "CheckOutFrom",
                                  "check_out_date_to"
                                )
                              }
                              value={dayjs(
                                state.check_out_date_from,
                                dateFormat
                              )}
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "1.3rem",
                                  backgroundColor: "transparent",
                                  border:
                                     
                                     "gray 1px solid",
                                  outline: DateError.CheckOutFrom ? "none" : "",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "transparent",
                                    },
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                              }}
                            />
                          </DemoContainer>

                          {DateError.CheckOutFrom ||
                          (DateError.CheckOutFrom &&
                            state.check_out_date_from == null) ? (
                            <div>
                              <p className="text-danger mt-3 f-bold ">
                                PLEASE SELECT CORRECT RETURN FROM DATE
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}

                          <label for="arrival_date" className="fs-2 mt-3">
                            {" "}
                            To
                          </label>

                          <DemoContainer
                            components={[
                              "DatePicker",
                              "MobileDatePicker",
                              "StaticDatePicker",
                            ]}
                            sx={{
                              "& .MuiInputBase-root": {
                                borderRadius: "10px",
                              },
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "transparent", // Prevents border from appearing
                                },
                              },
                              "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                            autoFocus={false}
                          >
                            <MobileDatePicker
                              value={dayjs(state.check_out_date_to, dateFormat)}
                              className=" "
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "1.3rem",
                                  backgroundColor: "transparent",
                                  border:
                                   
                                     "gray 1px solid",
                                  outline: DateError.CheckOutTo ? "none" : "",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "transparent",
                                    },
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                              }}
                              onChange={(e) =>
                                handle_date_to(
                                  e,
                                  "check_out_date_to",
                                  "CheckOutTo",
                                  "CheckOutFrom",
                                  "check_out_date_from"
                                )
                              }
                              autoFocus={false}
                            />
                          </DemoContainer>

                          {DateError.CheckOutTo ||
                          (DateError.CheckOutTo &&
                            state.check_out_date_to == null) ? (
                            <div>
                              <p className="text-danger mt-3 f-bold ">
                                PLEASE SELECT CORRECT RETURN TO DATE
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </>

                    {/* ARIVAL-------------------------------------------------------------- */}
                    <>
                      <label
                        for="arrival_date"
                        className="fs-1 text-center mt-3 "
                      >
                        Arrival Date
                      </label>

                      <div className="col-md-2 mb-1">
                        <div className="form-group">
                          <label for="arrival_date" className="fs-2">
                            {" "}
                            From
                          </label>

                          <DemoContainer
                            components={[
                              "DatePicker",
                              "MobileDatePicker",
                              "StaticDatePicker",
                            ]}
                            sx={{
                              "& .MuiInputBase-root": {
                                borderRadius: "10px",
                              },
                              "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "transparent",
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                          >
                            <MobileDatePicker
                              value={dayjs(state.arrival_date_from, dateFormat)}
                              onChange={(e) =>
                                handle_date_from(
                                  e,
                                  "arrival_date_from",
                                  "arivalErrorFrom",
                                  "arrival_date_to"
                                )
                              }
                              className=""
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "1.3rem",
                                  backgroundColor: "transparent",
                                  border: "gray 1px solid",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "transparent",
                                    },
                                    "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                                },
                              }}
                            />
                          </DemoContainer>

                          {DateError.arivalErrorFrom ||
                          (DateError.arivalErrorFrom &&
                            state.arrival_date_from == null) ? (
                            <div>
                              <p className="text-danger mt-3 f-bold ">
                                PLEASE SELECT CORRECT ARIVAL FROM DATE
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}

                          <label for="arrival_date" className="fs-2 mt-3">
                            {" "}
                            To
                          </label>
                          <DemoContainer
                            components={[
                              "DatePicker",
                              "MobileDatePicker",
                              "StaticDatePicker",
                            ]}
                            sx={{
                              "& .MuiInputBase-root": {
                                borderRadius: "10px",
                              },
                              "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "transparent",
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                            autoFocus={false}
                          >
                            <MobileDatePicker
                              value={dayjs(state.arrival_date_to, dateFormat)}
                              className=" "
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "1.3rem",
                                  backgroundColor: "transparent",
                                  border: "gray 1px solid",
                                  outline: DateError.arivalError ? "none" : "",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "transparent",
                                    },
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                              }}
                              onChange={(e) =>
                                handle_date_to(
                                  e,
                                  "arrival_date_to",
                                  "arivalError",
                                  "arivalErrorFrom",
                                  "arrival_date_from"
                                )
                              }
                              autoFocus={false}
                            />
                          </DemoContainer>

                          {DateError.arivalError ||
                          (DateError.arivalError &&
                            state.arrival_date_to == null) ? (
                            <div>
                              <p className="text-danger mt-3 f-bold ">
                                PLEASE SELECT CORRECT ARIVAL TO DATE
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </>
                    {/* RETURN-------------------------------------------------------------- */}

                    <>
                      <label
                        for="arrival_date"
                        className="fs-1 text-center mt-3 "
                      >
                        {" "}
                        Return Date{" "}
                      </label>
                      <div className="col-md-2 mb-1">
                        <div className="form-group">
                          <label for="arrival_date" className="fs-2">
                            {" "}
                            From
                          </label>

                          <DemoContainer
                            components={[
                              "DatePicker",
                              "MobileDatePicker",
                              "StaticDatePicker",
                            ]}
                            sx={{
                              "& .MuiInputBase-root": {
                                borderRadius: "10px",
                              },
                              "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "transparent",
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                          >
                            <MobileDatePicker
                              value={dayjs(state.return_date_from, dateFormat)}
                              onChange={(e) =>
                                handle_date_from(
                                  e,
                                  "return_date_from",
                                  "returnFrom",
                                  "return_date_to"
                                )
                              }
                              className=""
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "1.3rem",
                                  backgroundColor: "transparent",
                                  border: "gray 1px solid",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "transparent",
                                    },
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                              }}
                            />
                          </DemoContainer>

                          {DateError.returnFrom ||
                          (DateError.returnFrom &&
                            state.return_date_from == null) ? (
                            <div>
                              <p className="text-danger mt-3 f-bold ">
                                PLEASE SELECT CORRECT RETURN FROM DATE
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}

                          <label for="arrival_date" className="fs-2 mt-3">
                            {" "}
                            To
                          </label>
                          <DemoContainer
                            components={[
                              "DatePicker",
                              "MobileDatePicker",
                              "StaticDatePicker",
                            ]}
                            sx={{
                              "& .MuiInputBase-root": {
                                borderRadius: "10px",
                              },
                              "& .Mui-focused .MuiOutlinedInput-notchedOutline":
                                {
                                  borderColor: "transparent",
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                            }}
                            autoFocus={false}
                          >
                            <MobileDatePicker
                              value={dayjs(state.return_date_to, dateFormat)}
                              className=" "
                              sx={{
                                "& .MuiInputBase-root": {
                                  fontSize: "1.3rem",
                                  backgroundColor: "transparent",
                                  border: "gray 1px solid",
                                  "&.Mui-focused .MuiOutlinedInput-notchedOutline":
                                    {
                                      borderColor: "transparent",
                                    },
                                },
                                "& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove red border on error
          },
          "& .MuiOutlinedInput-notchedOutline": {
            border: "none", // remove default outline too
          },
                              }}
                              onChange={(e) =>
                                handle_date_to(
                                  e,
                                  "return_date_to",
                                  "returnTo",
                                  "returnFrom",
                                  "return_date_from"
                                )
                              }
                              autoFocus={false}
                              // Add custom class here
                            />
                          </DemoContainer>

                          {DateError.returnTo ||
                          (DateError.returnTo &&
                            state.return_date_to == null) ? (
                            <div>
                              <p className="text-danger mt-3 f-bold ">
                                PLEASE SELECT CORRECT RETURN TO DATE
                              </p>
                            </div>
                          ) : (
                            <></>
                          )}
                        </div>
                      </div>
                    </>

                    {/* Completed  */}

                    <div className="col-md-2 mb-4">
                      <div className="form-group">
                        <label htmlFor="completed" className="lableSize">
                          Completed
                        </label>
                        <select
                          className="form-control inputSizeForAllowHotel"
                          id="completed"
                          name="completed"
                          value={state.completed}
                          onChange={handleChange}
                          style={stylesInput}
                        >
                          <option value="">Please Select</option>
                          <option value="yes">Yes</option>
                          <option value="no" selected="">
                            No
                          </option>
                        </select>
                      </div>
                    </div>

                    <div
                      className="col-md-12"
                      id="AllowTransportActiviitesAjaxResult"
                    ></div>
                    <div className="col-md-12" id="FilterButtons">
                      <div className="form-group htjfdgr">
                        <button
                          style={{ marginRight: "10px" }}
                          disabled={!hasNoDateErrors} 
                            onClick={() => {
                          setActiveFilters(state);
                          setPage(0);
                        fetchData(state); }}
                         
                          id="btnsearch"
                          type="button"
                          className="btn btn-success serachandclearButtonpadding"
                        >
                          Search
                        </button>
                        <button
                         onClick={() =>{
   setActiveFilters(null);
                          setPage(0);
SetDateError({                      
     arivalErrorFrom: false,
    arivalError: false,
    returnFrom: false,
    returnTo: false,
    CheckOutFrom: false,
    CheckOutTo: false,
    checkInFrom: false,
    checkInTo: false})

                            setState({
                              length: 100,
                              start: 0,
                              draw: 1,
                              voucher_id: "",
                              agent_country: "",
                              
                              country: "",
                              agents: "",
                              city: 258342,
                              hotel: "",
                              check_in_date_from: null,
                              check_in_date_to: null,
                              check_out_date_from: null,
                              check_out_date_to: null,
                              arrival_date_from: null,
                              arrival_date_to: null,
                              checkInDateTo: null,
                              return_date_from: null,
                              return_date_to: null,
                              completed: "no",
                            })
                             fetchData()
                          }
                            
                          }
                          id="btnreset"
                          type="button"
                          className="btn btn-danger serachandclearButtonpadding ml-2"
                        >
                          Clear Filter
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </LocalizationProvider>
      </MDBContainer>

     
 <div style={{ marginBottom: "50px" }}>
        <Paper sx={{ padding: "0px 20px" }}>
          <Table
            id="example"
            className="table table-striped dt-responsive nowrap table-display w-100"
          >
            {/* Table Head */}
            <TableHead>
              <TableRow>
                <TableCell component="th" sx={{ fontWeight: "bold" }}>
                  Voucher
                </TableCell>
                <TableCell component="th" sx={{ fontWeight: "bold" }}>
                  {/* Actual Hotel */}
                  Hotel Name
                </TableCell>
                   <TableCell component="th" sx={{ fontWeight: "bold" }}>
                                Check In
                               </TableCell>
              </TableRow>
            </TableHead>

            {/* Table Body */}
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell
                    colSpan={3}
                    align="center"
                    style={{ height: "35vh" }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                      }}
                    >
                      <BounceLoader className="BouncingLoader" />
                    </div>
                  </TableCell>
                </TableRow>
              ) : totalRecords === 0 ? (
                <TableRow>
                  <TableCell
                    colSpan={3}
                    align="center"
                    style={{ height: "25vh" }}
                  >
                    <h3 className="pt-5">No data found</h3>
                  </TableCell>
                </TableRow>
              ) : (
                tableData?.map((item, index) => (
                  <React.Fragment key={index}>
                    <TableRow>
                      <TableCell
                        component="td"
                       
                        onClick={() => toggleExpansion(index)}

  sx={{
    cursor: "pointer",
    whiteSpace: "normal",   // allow text to wrap
    wordBreak: "break-word" // handle very long words without spaces
  }}


                      >
                        {/* {item?.voucher_id || "--"} */}
                        { item.voucher_id || "--"}
                      </TableCell>
                      <TableCell component="td">
                        
                        {item.hotel_name || "--" } 
                        
                      </TableCell>
                      <TableCell component="td">
                                             {item.check_in}
                                           </TableCell>
                    </TableRow>

                    {/* Expanded Row */}

                    {expandedRows[index] && (
                      <TableRow>
                        <TableCell component="td" colSpan={3}>
                          <div className="row">
                            {/* Select from item["1"] actions */}

                            {/* Other fields */}
                            {[
                            //  {
                            //     label: "Activity UID",
                            //     value: item.activity_uid,
                            //     colClass: "col-6",
                            //   },
                              {
                                label: "Room Type",
                                value: item.room_type_name || "--",
                                colClass: "col-6",
                              },
                              // {
                              //   label: "Check In Date",
                              //   value: item.check_in || "--",
                              //   colClass: "col-6",
                              // },
                              // {
                              //   label: "Check Out Date",
                              //   value: item.check_out || "--",
                              //   colClass: "col-6",
                              // },
                              {
                                label: "No Of Days",
                                value: item.days || "--",
                                colClass: "col-6",
                              },
                              // {
                              //   label: "No Of Bed",
                              //   value: item.no_of_bed || "--",
                              //   colClass: "col-6",
                              // },
                              // {
                              //   label: "City Name",
                              //   value: item.city_name || "--",
                              //   colClass: "col-6",
                              // },
                              // {
                              //   label: "Room Type Name",
                              //   value: item.room_type_name || "--",
                              //   colClass: "col-6",
                              // },
                              // {
                              //   label: "Arrival Date",
                              //   value: item.arrival_date || "--",
                              //   colClass: "col-6",
                              // },
                              // {
                              //   label: "Return Date",
                              //   value: item.return_date || "--",
                              //   colClass: "col-6",
                              // },
                              // {
                              //   label: "Voucher Id",
                              //   value: item.voucher_id || "--",
                              //   colClass: "col-6",
                              // },
                              // {
                              //   label: "Tax Pax",
                              //   value: item.tax_pax || "--",
                              //   colClass: "col-6",
                              // },
                              {
                                label: "Hotel Name",
                                value: item.hotel_name || "--",
                                colClass: "col-12",
                              },
                              // {
                              //   label: "Agent ",
                              //   value: item.agent || "--",
                              //   colClass: "col-12",
                              // },

                            ].map((field, idx) => (
                              <div
                                key={idx}
                                className={`${field.colClass} d-flex flex-column mb-3`}
                              >
                                <b>{field.label}:</b> {field.value}
                              </div>
                            ))}

                            {Array.isArray(item["1"]) && (
                              <div className="col-6 d-flex flex-column mb-3">
                                <label htmlFor={`action-select-${index}`}>
                                  <b>Action:</b>
                                </label>

                                <select
                                  id={`action-select-${index}`}
                                  className="form-select py-3"
                                  onChange={(e) => handleNavigate(e, index)}
                                  value={selectedActions[index] || ""}
                                >
                                  <option value="" disabled>
                                    -- Select an Action --
                                  </option>
                                  {item["1"].map((opt, idx) => (
                                    <option
                                      key={idx}
                                      value={opt.action.join(",")}
                                    >
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            )}
                          </div>
                        </TableCell>
                      </TableRow>
                    )}
                  </React.Fragment>
                ))
              )}
            </TableBody>

            <TablePagination
              rowsPerPageOptions={[10, 15, 20]}
              component="paper"
              count={totalRecords}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              sx={{
                "& .MuiTablePagination-displayedRows": { margin: 0 },
                "& .MuiTablePagination-selectLabel": { margin: 0 },
                "& .MuiSelect-select": { margin: 0 },
                 "& .MuiTablePagination-actions": { marginLeft: 0 }, 
              }}
            />
          </Table>
        </Paper>



<ActualHotalReturnModal
  open={openReturnVoucher}
  setOpen={setOpenReturnVoucher}
  sendDataToModal={sendDataToModal}

  


/>

        < AllowHotalModal
          heading={"Change Voucher Pilgrim's Status to Allow Hotel Madina"}
          open={open}
          setOpen={setOpen}
          sendDataToModal={sendDataToModal}   
          setSendDataToModal={setSendDataToModal}
           setSelectedActions={setSelectedActions}
           setFormVisible={setFormVisible}
        />
      </div>









      <div>{/* <BottomNavigationBar /> */}</div>
    </div>
  );
}

export default AllowHotelMakkahGridFilter;

// styles added here becouse not working in style sheets

const stylesInput = {
  borderRadius: "8px",
  height: "4.5rem",
  border: "1px solid gray",
};
